import Highcharts from 'highcharts';
import { BreakpointSizes } from '../../../enums/BreakpointSizes';
import { ChartTooltipFormatterService } from '../../../components/chart/services/ChartTooltipFormatterService';
import { CustomAny } from '../../../types/generics';
import { ChartValuesType } from '../../../components/chart/enums/ChartValuesType';
import { HtmlString } from '../../../types/HtmlString';
import { NumberHelper } from '../../../helpers/NumberHelper';
import { NumberFormat } from '../../../enums/NumberFormat';

export const annualRatingsPerformanceChart: Highcharts.Options = {
  chart: {
    spacingTop: 0,
    marginTop: 50,
  },
  title: {
    text: 'Annual Ratings Performance',
  },
  subtitle: {
    text: '3-Month Returns from Midpoint',
  },
  yAxis: {
    title: {
      text: 'Median 3-Month Return vs. Midpoint (%)',
    },
    labels: {
      formatter() {
        return NumberHelper.getFormatValue(this.value, NumberFormat.PercentageInteger);
      },
    },
    max: 1.5,
    min: -1,
  },
  xAxis: {
    categories: [
      '2007',
      '2008',
      '2009',
      '2010',
      '2011',
      '2012',
      '2013',
      '2014',
      '2015',
      '2016',
      '2017',
      '2018',
      '2019',
      '2020',
      '2021',
      '2022',
      '2023',
      '2024',
      '2025',
    ],
  },
  series: [
    {
      type: 'column',
      name: 'Outperform',
      data: [
        0.38,
        0.19,
        0.14,
        0.47,
        0.38,
        0.35,
        0.53,
        0.36,
        0.27,
        0.56,
        0.5,
        0.68,
        0.68,
        1.16,
        0.19,
        0.33,
        0.12,
        0.61,
        0.24,
      ],
    },
    {
      type: 'column',
      name: 'Underperform',
      data: [
        -0.18,
        -0.43,
        -0.3,
        -0.32,
        -0.07,
        -0.29,
        0.18,
        -0.28,
        -0.35,
        -0.1,
        -0.28,
        -0.08,
        -0.06,
        -0.54,
        -0.15,
        null,
        -0.34,
        -0.05,
        -0.45,
      ],
    },
  ],
  tooltip: {
    formatter() {
      return ChartTooltipFormatterService.getTooltip({
        points: this.points as CustomAny[],
        title: `${this.x}`,
        pointsValueType: ChartValuesType.Percentage,
      });
    },
  },
  plotOptions: {
    column: {
      dataLabels: {
        formatter(): HtmlString {
          return NumberHelper.getFormatValue(this.y, NumberFormat.PercentageInteger);
        },
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: BreakpointSizes.ExtraSmall,
        },
        chartOptions: {
          yAxis: {
            visible: false,
          },
        },
      },
    ],
  },
  credits: {
    enabled: false,
  },
};
